import { Activity, FC, RefObject, useRef } from 'react';
import { useOnClickOutside } from 'usehooks-ts';

import usePlankTableStore from '../../hooks/usePlankTableStore';

import SidepanelHeader from './Header/SidepanelHeader';
import SidepanelHeaderVoorraad from './Header/SidepanelHeaderVoorraad';
import SidepanelHeaderVoorraadRegionaal from './Header/SidepanelHeaderVoorraadRegionaal';
import TabNotitie from './Tabs/TabNotitie';
import TabStaat from './Tabs/TabStaat';
import TabVoorraad from './Tabs/TabVoorraad';
import TabVoorraadRegionaal from './Tabs/TabVoorraadRegionaal';

import styles from './Sidepanel.module.css';

const Sidepanel: FC = () => {
  const show = usePlankTableStore((state) => state.sidepanel.show);
  const tab = usePlankTableStore((state) => state.sidepanel.tab);
  const close = usePlankTableStore((state) => state.closeSidepanel);
  const isAccepteerDialogOpen = usePlankTableStore((state) => state.sidepanel.isAccepteerDialogOpen);
  const isTabVoorraad = usePlankTableStore((state) => ['Voorraad', 'VoorraadRegionaal'].includes(state.sidepanel.tab));
  const sublabel = usePlankTableStore((state) => state.sidepanel.sublabel);
  const isBusy = usePlankTableStore((state) => state.sidepanel.isBusy);
  const sidepanelRef = useRef<HTMLDivElement | null>(null);

  useOnClickOutside(sidepanelRef as RefObject<HTMLElement>, async () => {
    if (!isAccepteerDialogOpen && show) {
      if (tab === 'Notitie' && isBusy) {
        setTimeout(close, 30);
      } else close();
    }
  });

  return (
    <div
      id='ddp-sidepanel'
      ref={sidepanelRef}
      className={`${styles.sidepanelClosedStyle} ${show ? styles.show : ''} ${isTabVoorraad ? styles.thin : ''}`}
      tabIndex={0}
    >
      <div className={styles.sidepanelInnerStyle}>
        {isTabVoorraad ? (
          <>{tab === 'Voorraad' ? <SidepanelHeaderVoorraad /> : <SidepanelHeaderVoorraadRegionaal />}</>
        ) : (
          <SidepanelHeader />
        )}
        <div className={styles.spBodyDiv}>
          <Activity mode={tab === 'Staat' && sublabel !== 'Reserve' ? 'visible' : 'hidden'}>
            <TabStaat />
          </Activity>
          <Activity mode={tab === 'Notitie' ? 'visible' : 'hidden'}>
            <TabNotitie />
          </Activity>
          <Activity mode={tab === 'Voorraad' ? 'visible' : 'hidden'}>
            <TabVoorraad />
          </Activity>
          <Activity mode={tab === 'VoorraadRegionaal' ? 'visible' : 'hidden'}>
            <TabVoorraadRegionaal />
          </Activity>
        </div>
      </div>
    </div>
  );
};
export default Sidepanel;
